import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

const root = document.getElementById('root');
const theme = root.getAttribute('data-theme');

ReactDOM.createRoot(root).render(
  <App theme={theme} />
)
